<template>
    <!-- 添加数据2 -->
    <a-modal title="新增设置" v-model:open="open" @ok="handleOk" class="modals">
        <div class="push-input">
            <a><span class="startColor">*</span>参数名：</a>
            <a-input v-model:value="pushData.param" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>参数键：</a>
            <a-input v-model:value="pushData.paramKey" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>参数值：</a>
            <a-textarea v-model:value="pushData.paramValue" maxlength="200" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor"></span>备  注：</a>
            <a-textarea v-model:value="pushData.remark" maxlength="200" class="push-data" />
        </div>
        <template #footer>
            <a-button key="back" @click="toAddCancel">返回</a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">提交</a-button>
        </template>
    </a-modal>
</template>
<script>
import { saveSet } from '@/api/service';
import { message } from 'ant-design-vue';
import { ref } from 'vue';
export default {
    name: 'addComponent',
    setup() {
        const loading = ref(false);//添加提交时的加载
        const pushData = ref({});//提交数据
        const open = ref(false);//是否打开
        //关闭窗口
        const toAddCancel = () => {
            open.value = false;
        }
   
        //提交数据
        const handleOk = async () => {
            const response = await saveSet(pushData.value);
            if (response.code === 200) {
                message.success('添加成功');
                open.value = false;
            } else {
                message.error('添加失败' + response.msg);
                return false;
            }
        }
        return {
            loading,
            open,
            pushData,
            saveSet,
            toAddCancel,
            handleOk,
            ref
        };
    }
}
</script>
<style>
.push-input {
    display: flex;
    justify-content: space-between;
}

.modals {
    width: 400px;
}

.push-data {
    width: 80%;
}
</style>